import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import MainApp from "views/main-app";

import Login from "views/login/login.js";
import PrivateRoute from "util/private-route.js";
import "./scss/style.scss";
import {
  ROLE_ADMIN,
  USER_STORAGE,
  ROLE_USER,
  NOT_FOND,
  ROLE_USER_ADMIN,
} from "./constants";
import CashFlowClient from "views/client/cash-flow-client/cash-flow-client";
import IncomeStatement from "views/client/income-statement/income-statement";
import Expenses from "views/client/expenses/expenses";
import { useSelector } from "react-redux";
import { selectRole } from "reducer/login/login-user";
import Clients from "views/admin/client/clients";
import Page404 from "views/404/Page404";
import Users from "views/admin/user/users";
import AccountPlans from "views/admin/account-plan/account-plans";
import ImportData from "views/admin/import/import-data";
import BillsPay from "views/client/bills-pay/bills-pay";
import BillsReceive from "views/client/bills-receive/bills-receive";
import Budget from "views/admin/budget/budget";
import Categories from "views/admin/category/categories";
import CashFlowMonth from "views/client/cash-flow-client/cash-flow-month";
import MappingIncome from "views/admin/mapping-income/mapping-income";
import MappingCashFlow from "views/admin/mapping-cash-flow/mapping-cash-flow";
import AccountingIcome from "views/client/accounting/income";
import AccountingCashFlow from "views/client/accounting/cash-flow";
import Accounting from "views/client/accounting/accouting";
import AccountingBalance from "views/client/accounting/balance";
import KpiCashFlow from "views/client/kpi/cash-flow";
import Managerial from "views/client/managerial/managerial";
import CashFlowMonthAdmin from "views/admin/financial/cash-flow-month-admin";
import IncomeStatementAdmin from "views/admin/financial/income-statement-admin";
import RevenuesAndExpensive from "views/client/revenuesAndExpensive/revenuesAndExpensive";
import CostCenters from "views/client/cost-center/cost-centers";
import IncomeStatementV2 from "views/client/income-statement/income-statement-v2";

import KpiCashFlowV2 from "views/client/kpi/cash-flow-v2";
import ManagerialBi from "views/client/managerial/managerial-bi";

const RouterApp = (props) => {
  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { role } = JSON.parse(localStorageItem);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, []);

  function getNavegateApp() {
    let navegateApp =
      ROLE_ADMIN == roleRedux || ROLE_USER_ADMIN == roleRedux
        ? "/app/admin/client"
        : ROLE_USER == roleRedux
        ? "/app/client/managerial"
        : "/login";

    return navegateApp;
  }
  setTimeout(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);

    if (localStorageItem != null) {
      const { role } = JSON.parse(localStorageItem);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, 1000);

  function getCompanyType() {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem) {
      const { companyType } = JSON.parse(localStorageItem);
      return companyType;
    } else {
      return "";
    }
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route
            path="/app"
            element={<Navigate to={getNavegateApp()} replace />}
          />
          <Route
            path="/app/admin"
            element={<Navigate to={getNavegateApp()} replace />}
          />
          <Route
            path="/app/client"
            element={<Navigate to={getNavegateApp()} replace />}
          />
          <Route exact path="/app" element={<PrivateRoute />}>
            {(roleRedux == ROLE_ADMIN || roleRedux == ROLE_USER_ADMIN) && (
              <>
                <Route
                  path="/app/admin/client"
                  element={<MainApp component={<Clients />} />}
                />
                <Route
                  path="/app/admin/user"
                  element={<MainApp component={<Users />} />}
                />
                <Route
                  path="/app/admin/account-plan"
                  element={<MainApp component={<AccountPlans />} />}
                />
                <Route
                  path="/app/admin/import"
                  element={<MainApp component={<ImportData />} />}
                />
                <Route
                  path="/app/admin/budget"
                  element={<MainApp component={<Budget />} />}
                />
                <Route
                  path="/app/admin/category"
                  element={<MainApp component={<Categories />} />}
                />
                <Route
                  path="/app/admin/mapping-cash-flow"
                  element={<MainApp component={<MappingCashFlow />} />}
                />
                <Route
                  path="/app/admin/mapping-income"
                  element={<MainApp component={<MappingIncome />} />}
                />
                <Route
                  path="/app/admin/cash-flow"
                  element={<MainApp component={<CashFlowMonthAdmin />} />}
                />
                <Route
                  path="/app/admin/income"
                  element={<MainApp component={<IncomeStatementAdmin />} />}
                />
              </>
            )}

            {roleRedux == ROLE_USER && (
              <>
                <Route
                  path="/app/client/cash-flow"
                  element={<MainApp component={<CashFlowClient />} />}
                />
                <Route
                  path="/app/client/cash-flow-month"
                  element={<MainApp component={<CashFlowMonth />} />}
                />
                {/*  <Route
                  path="/app/client/income-statement"
                  element={<MainApp component={<IncomeStatement />} />}
                />
            */}
                <Route
                  path="/app/client/income-statement-v2"
                  element={<MainApp component={<IncomeStatementV2 />} />}
                />
                <Route
                  path="/app/client/revenues"
                  element={
                    <MainApp
                      component={
                        <RevenuesAndExpensive type={"CONTA_A_RECEBER"} />
                      }
                    />
                  }
                />
                <Route
                  path="/app/client/expenses"
                  element={
                    <MainApp
                      component={
                        <RevenuesAndExpensive type={"CONTA_A_PAGAR"} />
                      }
                    />
                  }
                />

                {/*<Route
                    path="/app/client/kpi/cash-flow"
                    element={<MainApp component={<KpiCashFlow />} />}
                  />
                */}
                <Route
                  path="/app/client/kpi/cash-flow-v2"
                  element={<MainApp component={<KpiCashFlowV2 />} />}
                />

                <Route
                  path="/app/client/bills-pay"
                  element={<MainApp component={<BillsPay />} />}
                />
                <Route
                  path="/app/client/bills-receive"
                  element={<MainApp component={<BillsReceive />} />}
                />
                <Route
                  path="/app/client/accounting-income"
                  element={<MainApp component={<AccountingIcome />} />}
                />
                <Route
                  path="/app/client/accounting-cash-flow"
                  element={<MainApp component={<AccountingIcome />} />}
                />
                <Route
                  path="/app/client/accounting"
                  element={<MainApp component={<AccountingIcome />} />}
                />
                <Route
                  path="/app/client/accounting-balance"
                  element={<MainApp component={<AccountingIcome />} />}
                />

                {getCompanyType() == "BI" && (
                  <Route
                    path="/app/client/managerial"
                    element={<MainApp component={<ManagerialBi />} />}
                  />
                )}    
                {getCompanyType() == "BI_V2" && (
                  <Route
                    path="/app/client/managerial"
                    element={<MainApp component={<Managerial />} />}
                  />
                )}
                {getCompanyType() != "BI" &&  getCompanyType() != "BI_V2" &&(
                  <Route
                    path="/app/client/managerial"
                    element={<MainApp component={<Managerial />} />}
                  />
                )}

                <Route
                  path="/app/client/cost-center"
                  element={<MainApp component={<CostCenters />} />}
                />
              </>
            )}
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default RouterApp;
